import React from 'react'
import { RiEyeOffLine } from "react-icons/ri"
import { FcGoogle } from "react-icons/fc";
import { BsInstagram } from "react-icons/bs";
import { IoIosArrowBack } from "react-icons/io"


function Login() {
  return (
    <>
      <section className="WP-container">
        {/* <a className="back-wel" href="./"> <IoIosArrowBack />Back</a> */}
        <div className="Welcome-Container-1">
          <h1 className="Welcome-H">Welcome Back</h1>
          <p className="Welcome-P">Login to access all your business management tools on one place</p>
        </div>
        <form action="POST" className="Login-Form2">

          <div className="Welcome-Input-container">
            <label for="email-address" className="EA-Welcome">Email Address</label>
            <input type="email" name="email" placeholder="Moyosade@gmail.com" id="email-Welcome" className="email-Welcome" required />
          </div>

          <div className="Welcome-Input-container">
            <label for="password" className="PS-Welcome">Password</label>
            <input type="password" name="password" placeholder="*****************" minLength="8" maxLength="15" id="password" className="password-Welcome" required />
            {/* <span className="eye1">< RiEyeOffLine /></span> */}
          </div>

          <div className="Login-Button-Container">
            <button type="submit" className="button-Welcome">Login</button>

          </div>
        </form>
        <div className="Welcome-Container-2">
          <p className="Welcome-P2">Not a user yet?<a className="sign-link" href="./SignUp">Sign Up</a> to join us!</p>
          <p className="Welcome-P3">Or sign up using  <FcGoogle /> <BsInstagram /></p>
        </div>
      </section >
    </>
  )
}

export default Login
